  <div class="filterCard">
  <div class="mt-2 mb-3">
    <div class="filterCartInner position-relative d-flex align-items-center">
      <span class="paragraph mr-3">
        {{mls.languageText.connection_request_list.key7}}
      </span>
      <div class="connectionSuggestionFilter">
        <div class="custom-owl-carousel owl-carousel-wrapper connection-suggestion-filter">
          <owl-carousel-o [options]="customOptionsNudge">
            <ng-template *ngFor="let data of suggestionFilter;let Index = index" carouselSlide>
              <span [ngClass]="{'SelectedFilter':Index === filterIndex}"
                (click)="applyFilter(Index, data)" class="connection-container">
                <span type="radio" name="radio1" id="male"></span>
                <span class="chip large outline" title={{data.value}}>
                  {{data.value|slice:0:19}}
                  <span *ngIf="data.value.length > 19">...</span>
                </span>
              </span>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
    </div>
  </div>  
</div>